module.exports = "<!-- <H3>\n  CAuth Component\n</H3>\n\n<p>\n  Action: {{ model.action }}\n</p>\n<p>\n  id_token from cognito: {{ model.id_token }}\n</p> -->\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/cauth/cauth.component.html
// module id = ../../../../../src/app/cauth/cauth.component.html
// module chunks = main